import React from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';
import cn from 'classnames';
import _isFunction from 'lodash/isFunction';
import styles from './index.module.scss';

import { If } from 'utils';
import { useAppContext } from 'utils/hooks';
import { ReactComponent as BackIcon } from 'assets/img/icons/previous-page.svg';

export default function ContainerCard({
  title = '',
  className = '',
  onBackClick = undefined,
  children = null
}) {
  const { appName } = useAppContext();

  return (
    <Card className={cn(styles.card, className)}>
      <CardBody className={styles.body}>
        <div className={styles.header}>
          <If test={_isFunction(onBackClick)}>
            <div role="button" onClick={onBackClick} className={styles.backBtn}>
              <BackIcon /> Back
            </div>
          </If>
          <CardTitle className={styles.title}>
            {title || `Connect with ${appName}`}
          </CardTitle>
        </div>
        {children}
      </CardBody>
    </Card>
  );
}
